import { render, staticRenderFns } from "./loanAccountConfig.vue?vue&type=template&id=7214ddc4"
import script from "./loanAccountConfig.vue?vue&type=script&lang=js"
export * from "./loanAccountConfig.vue?vue&type=script&lang=js"
import style0 from "./loanAccountConfig.vue?vue&type=style&index=0&id=7214ddc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports